import css from "./style.scss";
import cx from "classnames";
import {formatNumber} from "../../helpers/formatters-helpers";
import useInvoice from "../../hooks/useInvoice";

const CryptoListItem = ({ item }) => {
  const { selectCurrency } = useInvoice();
  const { name, value, currency, icon } = item;

  const handleSelectCurrency = (selectedItem) => {
    const network = selectedItem.types.length === 1 ? selectedItem.types[0] : null;
    selectCurrency(item, network)
  };

  return (
    <li
      onClick={() => handleSelectCurrency(item)}
      class={cx(css.item)}
    >
      <div class={cx(css.icon)}>{icon()}</div>
      <div class={cx(css.name)}>{name}</div>
      <div class={cx(css.value)}>
        {formatNumber(value)} {currency}
      </div>
    </li>
  );
};

const CryptoList = () => {
  const { invoice } = useInvoice();
  return (
    <ul class={cx(css.list)}>
      {invoice.currencyList.map((el) => (
        <CryptoListItem item={el} />
      ))}
    </ul>
  );
};

export default CryptoList;
